<button class="btn btn-primary btn-sm" (click)="openModal()" style="width: 100%;">{{ButtonName}}</button>

<ng-template #IndentItemModal>
  <div class="modal-header">
    <h5 class="modal-title">{{ButtonName}}</h5>
    <button type="button" class="btn-close" (click)="IndentModalRef.close()"></button>
  </div>

  <div class="modal-body">
    <div *ngIf="alertMessage" [class]="'alert alert-' + alertType" role="alert" style="padding: 8px 12px; margin-bottom: 12px;">
      {{alertMessage}}
    </div>
    <!-- <div class="mb-3">
      <label for="indentNo" class="form-label">Indent No<span style="color: red;">*</span></label>
      <ng-select (search)="SearchIndent($event)" [items]="IndentList" bindValue="indentId" [loading]="searchLoading"
        bindLabel="indentNo" [formControl]="IndentNo">
      </ng-select>
    </div> -->
    <div class="mb-3">
      <div class="table-wrapper card">
        <table class="row-border hover table table-bordered com_table" style="width: 100%;">
          <thead>
            <tr class="text-dark" style="border-left: 5px solid var(--bs-primary);">
              <th scope="col" style="width: 20px;"><input type="checkbox" (change)="onSelectAllCheckboxChange($event)"></th>
              <th scope="col">Item Name</th>
              <th scope="col">Description</th>
              <!-- <th scope="col" class="vendor-filter-header">
                Vendor
                <button class="filter-icon-btn" [class.active]="showVendorFilter" [class.filtered]="selectedVendor !== null && selectedVendor !== undefined" (click)="toggleVendorFilter()" title="Filter by Vendor">
                  <i class="bi" [class.bi-funnel]="!showVendorFilter && !selectedVendor" [class.bi-funnel-fill]="showVendorFilter || selectedVendor" style="font-size: 14px;"></i>
                  <span class="filter-badge" *ngIf="selectedVendor !== null && selectedVendor !== undefined">●</span>
                </button>
                <div class="vendor-filter-dropdown" *ngIf="showVendorFilter">
                  <ng-select [(ngModel)]="selectedVendor" [items]="VendorList" bindValue="vendorId" bindLabel="vendorName" 
                    placeholder="All Vendors" (change)="onVendorFilterChange()" [clearable]="true" class="vendor-filter-select">
                  </ng-select>
                </div>
              </th> -->
              <th scope="col">Quantity</th>
              <th scope="col" style="width: 120px;">Rate
                <input type="number" class="form-control form-control-sm" *ngIf="ifItemsSelected && EnablePriceEdit" (input)="patchCommonPrice($event)">
              </th>
            </tr>
          </thead>
          <tbody id="IndentListBody">
            <tr *ngFor="let items of filteredIndentDetailItems">
              <td style="width: 50px;">
                <input type="checkbox" [checked]="items.isSelected" (change)="onSelctionCheckboxChange($event,items)">
              </td>
              <td>{{items.itemNo}}</td>
              <td>{{items.itemDetails}}</td>
              <!-- <td>{{items.vendorName}}</td> -->
              <td style="width: 120px;">
                <input type="number" class="form-control form-control-sm" 
                  [ngModel]="items.availableQty"
                  [max]="items.qty"
                  (change)="validateAndUpdateQty(items, $event)"
                  [disabled]="!items.isSelected">
              </td>
              <td style="width: 150px;">
                <input type="number" class="form-control form-control-sm" *ngIf="items.isSelected && EnablePriceEdit" [(ngModel)]="items.price">
              </td>
            </tr>
            <tr *ngIf="dataLoading">
              <td><ngx-skeleton-loader [appearance]="'line'"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader [appearance]="'line'"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader [appearance]="'line'"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader [appearance]="'line'"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader [appearance]="'line'"></ngx-skeleton-loader></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="modal-footer text-end">
    <button class="btn btn-sm btn-primary" [disabled]="isSubmitting" (click)="submitResults()">
      <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm  me-1" role="status" aria-hidden="true"></span>
      <span>{{ isSubmitting ? 'Submitting...' : 'Submit' }}</span></button>
    <button class="btn btn-sm btn-secondary" (click)="IndentModalRef.close()">Close</button>
  </div>
</ng-template>
